import { IHttpMethodConfig, IValidationError } from './types';

export function validateRequestData(method: IHttpMethodConfig, data: Record<string, any>): IValidationError[] {
	const errors: IValidationError[] = [];

	if (!method.validation) {
		return errors;
	}

	Object.entries(method.validation).forEach(([field, rules]) => {
		const value = data[field];

		if (rules.required && (value === undefined || value === null || value === '')) {
			errors.push({
				field,
				message: `${field} is required`,
			});
			return;
		}

		if (value !== undefined && value !== null && rules.type) {
			const type = typeof value;
			if (type !== rules.type) {
				errors.push({
					field,
					message: `${field} must be of type ${rules.type}`,
				});
			}
		}
	});

	return errors;
}

export function validateEndpoint(endpoint: string, data: Record<string, any>): string {
	let finalEndpoint = endpoint;

	Object.entries(data).forEach(([key, value]) => {
		finalEndpoint = finalEndpoint.replace(`:${key}`, String(value));
	});

	return finalEndpoint;
}
